import script from "./ApiPath.vue?vue&type=script&lang=js"
export * from "./ApiPath.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__